import { fetcher } from "@website/fetcher/fetcher";
import { applicationStore } from "@website/store/store";
import { useSnackbar } from "@website/ui/snackbar";
import get from "lodash-es/get";
import omit from "lodash-es/omit";
import toNumber from "lodash-es/toNumber";
import toString from "lodash-es/toString";
import { useRouter } from "next/router";
import { useCallback } from "react";
import { ENDPOINTS } from "../../../constants";
import { HotelCreateBookPropertiesTypes } from "./index.types";

export const useHotelCreateBook = () => {
  const router = useRouter();
  const { enqueue } = useSnackbar();
  const createBookRefetch = useCallback(
    (properties: HotelCreateBookPropertiesTypes) => {
      const {
        hotelId,
        roomId,
        bookNeedConfirm,
        bookType,
        promotion,
        provider,
        availableRooms,
        dateFrom,
        dateTo
      } = properties;
      const roomCount = Number.isNaN(toNumber(get(router.query, "no_rooms")))
        ? 1
        : toNumber(get(router.query, "no_rooms")) <= availableRooms
          ? toNumber(get(router.query, "no_rooms"))
          : availableRooms;

      const roomDetails = Array?.from({ length: roomCount }, () => ({
        room_id: roomId
      }));
      return fetcher({
        url: ENDPOINTS.CREATE_BOOK,
        method: "POST",
        params: {
          "api-id": "Jek",
          token: "Jek"
        },
        data: {
          adult_count: toNumber(get(router.query, "adults")) || 1,
          app: "desktop-web-fa",
          app_id: "app",
          book_need_confirm: Boolean(bookNeedConfirm),
          booking_details: roomDetails,
          booking_source: "Online",
          booking_type: bookType,
          currency_unit: "IRR",
          date_from: dateFrom || toString(get(router.query, "date_from")),
          date_to: dateTo || toString(get(router.query, "date_to")),
          hotel_id: hotelId,
          infant_count: toNumber(get(router.query, "children")) || 0,
          promotion: { average_discount_percent: promotion || 0 },
          referrer: "snapptrip",
          room_provider: provider || ""
        }
      })
        .then(({ data }) => {
          applicationStore.shopping?.requisition?.set("");
          applicationStore.shopping?.passengerInfo?.set([]);
          return router.push(
            {
              pathname: "/shopping/[shopId]/detail",
              query: {
                ...omit(router.query, ["cityTitle", "hotelTitle"]),
                shopId: data?.id,
                gid: data?.gid
              }
            },
            undefined,
            { shallow: true, scroll: false }
          );
        })
        .catch((error) =>
          enqueue(error?.response?.message, "error", "one-line")
        );
    },
    [enqueue, router]
  );
  return {
    createBookRefetch
  };
};
